export const SCEN = [
  { k: "downside", label: "Downside" },
  { k: "base", label: "Base" },
  { k: "upside", label: "Upside" },
];

export const CHANNELS = [
  { k: "physical", label: "Physical" },
  { k: "digital", label: "Digital" },
  { k: "dinner", label: "Dinner" },
];
export const CHANNEL_LABEL = Object.fromEntries(CHANNELS.map((c) => [c.k, c.label]));

export const STAGES = [
  { k: "researching", label: "Researching" },
  { k: "ready", label: "Ready to contact" },
  { k: "outreach_sent", label: "Outreach sent" },
  { k: "waiting", label: "Waiting" },
  { k: "dialogue", label: "Dialogue" },
  { k: "interested", label: "Interested" },
  { k: "confirmed", label: "Confirmed" },
];
export const STAGE_LABEL = Object.fromEntries(STAGES.map((s) => [s.k, s.label]));
STAGE_LABEL.declined = "Declined";

export const CATEGORIES = [
  { k: "venue", label: "Venue & Hospitality" },
  { k: "production", label: "Production & Broadcast" },
  { k: "speakers", label: "Speakers" },
  { k: "marketing", label: "Marketing & Brand" },
  { k: "experience", label: "Experience & Operations" },
  { k: "team", label: "Team & Admin" },
];
export const CAT_LABEL = Object.fromEntries(CATEGORIES.map((c) => [c.k, c.label]));

export const BEHAVIORS = [
  { k: "fixed", label: "Fixed" },
  { k: "per_physical", label: "Per physical attendee" },
  { k: "per_digital", label: "Per digital attendee" },
  { k: "per_dinner", label: "Per dinner guest" },
  { k: "stepped", label: "Tiered" },
  { k: "pct_revenue", label: "% of revenue" },
  { k: "allowance", label: "Planning allowance (auto-remainder)" },
];
export const BEH_LABEL = Object.fromEntries(BEHAVIORS.map((b) => [b.k, b.label]));

export const STATUSES = [
  { k: "planned", label: "Planned" },
  { k: "quoted", label: "Quote received" },
  { k: "contracted", label: "Contracted" },
  { k: "invoiced", label: "Invoiced" },
  { k: "paid", label: "Paid" },
];
export const STATUS_LABEL = Object.fromEntries(STATUSES.map((s) => [s.k, s.label]));

export const SPONSOR_MODES = [
  { k: "committed_only", label: "Signed only" },
  { k: "weighted", label: "Weighted pipeline" },
  { k: "optimistic", label: "Optimistic (≥ proposal in full)" },
];
export const MODE_LABEL = Object.fromEntries(SPONSOR_MODES.map((m) => [m.k, m.label]));

export const nok = (n) => `${Math.round(Number(n) || 0).toLocaleString("nb-NO")}`;

export function kompakt(n) {
  const v = Number(n) || 0;
  const abs = Math.abs(v);
  if (abs >= 1e6) return `${(v / 1e6).toFixed(2)}m`;
  if (abs >= 1e3) return `${Math.round(v / 1e3)}k`;
  return `${Math.round(v)}`;
}

export function fortegn(n) {
  const v = Number(n) || 0;
  return v > 0 ? `+${kompakt(v)}` : kompakt(v);
}

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export function monthLabel(m) {
  if (!m || m.length < 7) return m || "";
  return `${MONTHS[Number(m.slice(5, 7)) - 1]} ${m.slice(2, 4)}`;
}

export function prodLabel(factor) {
  const f = Number(factor) || 1;
  if (f < 1) return "Lean";
  if (f > 1) return "Premium";
  return "Base";
}

export const miniInput =
  "w-[72px] text-[12.5px] border border-[#DED9CD] rounded-lg px-2 py-1 text-right tabular-nums bg-white focus:outline-none focus:border-neutral-900 transition-colors";
